import { useEffect, useState } from "react"
import { Alert, Button, Container, Table } from "reactstrap"
import Utils from "../../Utils"
import { Link } from "react-router-dom"

const ListarPendientes = () => {

    const [pendientes, setPentientes] = useState(null)

    const fetchPremiosPendientes = async () => {
        try {
            const { data } = await Utils.API.CanjesPendientes()
            setPentientes( data)
            //
        } catch(err) {
            Utils.AlertError(err, "No se pudo cargar la lista de premios pendientes de entrega")
        }
    }

    const entregarPremio = async (idCanje) => {
        if(window.confirm(`Realmente desea amrcar el premio como entregado?`) == false) {
            return;
        }
        // try
        try {
            await Utils.API.EntregarPremio(idCanje)
            fetchPremiosPendientes()
            //s
        } catch(err) {
            Utils.AlertError(err, "No se pudo marcar el premio como entregado")
        }
    }

    useEffect(() => {
        fetchPremiosPendientes()
    }, [])

    return(
        <Container>
            {(pendientes == null) ?
                <Alert className="text-center h3" color="info">Cargando...</Alert>
                :
                <>
                    <Table hover className="my-2 text-center" bordered>
                        <thead>
                            <tr className="table-info">
                                <th>Premio</th>
                                <th>DNI</th>
                                <th>Nombre</th>
                                <th>Celular</th>
                                <th>Registro</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendientes.map(user => (
                                <tr key={user.idCanje}>
                                    <td>{user.Nombre}</td>
                                    <td>{user.DNI}</td>
                                    <td>{user.Persona}</td>
                                    <td>{user.Celular}</td>
                                    <td>{Utils.dayjs(user.FechaSolicitud).format("LLL")}</td>
                                    <td>
                                        <Button onClick={() => { entregarPremio(user.idCanje) }} outline className="m-2">Entregar Premio</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            }
        </Container>
    )
}

export default ListarPendientes